import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  CACHE_SIZE_UNLIMITED,
} from "firebase/firestore";
import { initializeAuth, indexedDBLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCw6lHdtytHWUQR8YDenGym-3LVf8rqZ_o",
  authDomain: "granamericas.firebaseapp.com",
  projectId: "granamericas",
  storageBucket: "granamericas.firebasestorage.app",
  messagingSenderId: "715855272863",
  appId: "1:715855272863:web:22878c7d53bd1279607baa",
  measurementId: "G-RKRB2FWZ2B",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
    cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  }),
});
const auth = initializeAuth(app, {
  persistence: indexedDBLocalPersistence,
});
export { db, auth };
